import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} fill="none" {...props}>
    <path fill="#616061" d="M7.293 3.707 0 11v4h4l7.293-7.293zM8.707 2.293l4 4 1.465-1.465a2.829 2.829 0 0 0-4-4z" />
  </svg>
);
export default SvgEdit;
